import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Dialog from './components/dialog/Dialog';
import LocaleContext from './contexts/localeContext';
import PermissionProvider from "./contexts/PermissionProvider/PermissionProvider";
import { IcaWebsocketContextProvider } from './contexts/websocket/IcaWebsocketContextProvider';
import AccessControl from './pages/access-control/index';
import Login from './pages/login';
import PrivateRoute from './PrivateRoute';
import Providers from "./Providers";
import ssoLogin from "./pages/sso/SsoLogin";

const fetchPermission = (user) => async (permission) => {
    return user?.permissions?.includes(permission);
}

const App = () => {
    const user = useSelector((state) => state.userInfo);
    return (
        <div className="h-screen w-full">
            <LocaleContext>
                <Dialog>
                    <PermissionProvider fetchPermission={fetchPermission(user)}>
                        <Providers>
                            <IcaWebsocketContextProvider user={user}>
                                <Switch>
                                    <PrivateRoute exact path="/" component={AccessControl} strict={false}></PrivateRoute>
                                    <PrivateRoute path="/access-control" component={AccessControl} strict={false}></PrivateRoute>
                                    <Route path="/login" component={Login}></Route>
                                    <Route path="/sso/login" component={ssoLogin}></Route>
                                </Switch>
                            </IcaWebsocketContextProvider>
                        </Providers>
                    </PermissionProvider>
                </Dialog>
            </LocaleContext>
        </div >
    )
}

export default App;
